import { Route, Routes } from "react-router-dom";
import MenuHeader1 from "./MenuHeader1";
import NewPrescription from "./Prescriptions/NewPrescription";
import UpdatePatient from "./Patients/UpdatePatient";
import Dashboard from "./Dashboard/Dashboard";
import MyFacilityHome from "./FacilitySettings/MyFacilityHome.js";
import { Links } from "./Utility/Constants.js";
import PatientHome from "./Patients/PatientHome.js";
import AppointmentsHome1 from "./Appointments/AppointmentsHome1.js";
import { AppBar, Box, Grid2, Toolbar } from "@mui/material";
import MyWorklistHome from "./Worklist/MyWorklistHome.js";
import BillHome from "./Billing/BillHome";
import BillList from "./Billing/BillList";

function MasterPage() {
  
  return (
    <Grid2 direction="column" sx={{ height: "100vh", width: "100%" }} overflow="hidden">
      <MenuHeader1></MenuHeader1>
      <Grid2 sx={{ height: "95vh",  marginTop: "50px", marginLeft: "52px" }} overflow="hidden">
        {/* <Grid2 size={12} overflow="hidden" sx={{ height: "100vh" }}> */}
        <Routes>
        <Route path={Links.root} element={<MyWorklistHome></MyWorklistHome>} />
        <Route path={Links.dashboard} element={<Dashboard></Dashboard>} />

        <Route
          path={Links.allAppointments}
          element={<AppointmentsHome1></AppointmentsHome1>}
        />
        <Route
          path={Links.myWorklist}
          element={<MyWorklistHome key='1'></MyWorklistHome>}
        />
        <Route
          path={Links.todayQueue}
          element={<AppointmentsHome1></AppointmentsHome1>}
        />
        <Route
          path={Links.newAppointment}
          element={<AppointmentsHome1></AppointmentsHome1>}
        />
        <Route
          path={Links.rescheduleAppointment}
          element={<AppointmentsHome1></AppointmentsHome1>}
        />
        <Route path={Links.patient} element={<PatientHome></PatientHome>}></Route>
        <Route path={Links.basicInformation} element={<PatientHome></PatientHome>}></Route>
        <Route path={Links.prescriptions} element={<PatientHome></PatientHome>}></Route>
        <Route path={Links.medicalRecords} element={<PatientHome></PatientHome>}></Route>

        <Route path={Links.updatePatient} element={<UpdatePatient></UpdatePatient>}></Route>


        <Route path={Links.newPrescription} element={<NewPrescription></NewPrescription>} />

        <Route path={Links.facilityBasicDetails} element={<MyFacilityHome></MyFacilityHome>} />
        <Route path={Links.facilityService} element={<MyFacilityHome></MyFacilityHome>} />
        <Route path={Links.facilityStaff} element={<MyFacilityHome></MyFacilityHome>} />

        <Route path={Links.patientAnalytics} element={<Dashboard></Dashboard>} />
        <Route path={Links.schedulingAnalytics} element={<Dashboard></Dashboard>} />
        <Route path={Links.others} element={<label>This page is under construction</label>} />

        <Route path={Links.billing} element={<BillHome />} />
            <Route path={Links.billingHome} element={<BillHome />} />
            <Route path={Links.billingList} element={<BillList />} />

      </Routes>
        {/* </Grid2> */}
      </Grid2>
    </Grid2>
  );
}

export default MasterPage;
